export const AGENCY_SHIFTS_FETCH_BEGIN = 'syftacp/AGENCY_SHIFTS_FETCH_BEGIN' as const
export const AGENCY_SHIFTS_FETCH_FAILED = 'syftacp/AGENCY_SHIFTS_FETCH_FAILED' as const
export const AGENCY_SHIFTS_FETCH_SUCCEEDED = 'syftacp/AGENCY_SHIFTS_FETCH_SUCCEEDED' as const
